module.exports = __webpack_public_path__ + "static/media/gatsibo_model_village4.04190ec9.jpg";